import React from 'react'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

export function confirmationDialog(options) {
    return confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className="border p-4" style={{ width: '400px' }}>
                    <h4 className="text-primary mb-4">{options.title}</h4>
                    <p className="text-muted mb-4">{options.text}</p>

                    <div className="row text-center mx-2">
                        <div className="col-sm-6">
                            <button
                                className={`btn btn-sm btn-${options.positiveColor}`}
                                onClick={() => {
                                    options.positiveCallback &&
                                        options.positiveCallback()
                                    onClose()
                                }}>
                                {options.positiveText}
                            </button>
                        </div>

                        <div className="col-sm-6">
                            <button
                                className={`btn btn-sm btn-${options.negativeColor}`}
                                onClick={() => {
                                    options.negativeCallback &&
                                        options.negativeCallback()
                                    onClose()
                                }}>
                                {options.negativeText}
                            </button>
                        </div>
                    </div>
                </div>
            )
        },
    })
}
